import { render, staticRenderFns } from "./template-work-order-edit-form.html?vue&type=template&id=40236a5f&scoped=true&"
import script from "./template-work-order-edit-form.ts?vue&type=script&lang=js&"
export * from "./template-work-order-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40236a5f",
  null
  
)

export default component.exports